import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'

const FWA = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="typing-on-macbook.png"
                  alt="People working on laptop together"
                />
              </div>
              <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-32">
                <h1 className="text-4xl tracking-tight font-extralight sm:text-5xl lg:text-6xl text-blue-dark">
                  Fraud, Waste and Abuse
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8 text-grey">
            <p className="pb-8">
              In healthcare, fraud refers to knowingly and willfully obtaining,
              or attempting to obtain, money or property through false
              representations or promises. Waste is performing unnecessary
              services, overutilizing services, or billing for unnecessary
              services all of which result in avoidable costs to the system.
              Abuse results from activities that are not done in accordance with
              generally accepted industry standards, leading to more unnecessary
              payments and services. These harmful activities can be performed
              by medical providers, businesses, or a health plan’s members.
            </p>
            <p className="pb-8">
              FWA is estimated to add up to as much as 35% of all healthcare
              spending in the United States.<sup className="text-xs">1</sup>{' '}
              It’s a significant problem in the industry that medical providers,
              hospitals, insurers, and other parties face daily. This can lead
              to poorer medical outcomes for you and higher costs for everyone.
            </p>
            <p className="pb-8">
              Evry Health’s Special Investigations Unit (SIU) works to detect,
              stop, prevent, investigate, and fix all forms of fraud, waste, and
              abuse. One way this group can do its job is through helpful
              reports of suspected FWA from our members, physicians, and the
              public at large.
            </p>
            <p className="text-xs text-grey-dark">
              <sup className="text-[10px] ">1. </sup>
              Berwick DM, Hackbarth AD. Eliminating waste in US health care.
              JAMA. 2012 Apr 11;307(14):1513-6. doi: 10.1001/jama.2012.362. Epub
              2012 Mar 14. PMID: 22419800.
            </p>

            <p class="font-extrabold pb-8 pt-8">
              We encourage you to call the SIU at
              <a class="text-green" href="tel:+18555793879">
                {' '}
                1-855-579-3879
              </a>{' '}
              and report any suspected fraud, waste, or abuse. Your report can
              be submitted completely anonymously.
            </p>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default FWA
